import { APIResponse, RentalData } from '../../@types';
import { makeAPICall } from './clientHelpers/makeAPICall';

export const serviceClient = {
  getServices: async (): Promise<APIResponse<Array<RentalData>>> => {
    const { notModified, data, error } = await makeAPICall({
      method: 'GET',
      url: '/services',
    });
    return {
      notModified,
      data,
      error,
    };
  },
};
